import { useAnimations, useFBX } from '@react-three/drei';
import { useEffect, useRef } from 'react';
import * as THREE from 'three';
import { Group } from 'three';

type CharacterProps = {
  url: string;
  position?: [number, number, number];
  rotation?: [number, number, number];
  scale?: number | [number, number, number];
};

export function Character(props: CharacterProps) {
  const { url, position = [0, 0, 0], rotation = [0, 0, 0], scale = 1, ...rest } = props;
  const fbx = useFBX(url);
  const groupRef = useRef<Group>(null);
  const { actions, names } = useAnimations(fbx.animations, groupRef);

  // Play the first animation clip
  useEffect(() => {
    if (actions && names.length > 0) {
      const action = actions[names[0]];
      if (action) {
        action.reset().fadeIn(0.5).play();
      }
    }
  }, [actions, names]);

  return (
    <group
      ref={groupRef}
      position={position}
      scale={scale}
      castShadow
      receiveShadow
      rotation={rotation.map(THREE.MathUtils.degToRad) as [number, number, number]}
      onPointerOver={(e) => {
        e.stopPropagation();
      }}
      onPointerOut={(e) => {
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.stopPropagation();
      }}
      {...rest}
    >
      <primitive castShadow receiveShadow object={fbx} />
    </group>
  );
}
